module.exports = __webpack_public_path__ + "static/media/waterFilterWrong.f1583d99.png";